import { useReselector } from '@/utils/sharedHooks'
import { useAnalyticsTrack } from '@/features/amplitude'
import { PostOnboardingTaskIdents } from '@/features/onboarding/config'
import { OnboardingEstimatedTaxPaymentsModal } from '@/features/onboarding/OnboardingEstimatedTaxPaymentsModal'
import { PayrollComplianceDialog } from '../PayrollComplianceDialog'
import { selectUserActionItemById } from './lib/userActionItems.selectors'
import { markUserActionItemCompleteIfExists } from '../lib/service'
import { UserActionItemActionItemIdentifiers } from './lib/userActionItems.slice'
import { selectCurrentAnnualTaxYear } from '@/features/admin/annual-tax-details/annualTaxDetails.selector'
import { selectDocumentCategoryByUserActionItemId } from '@/features/admin/user-document-categories/userDocumentCategories.selectors'
import { PayrollTaskIdents } from '@/features/payroll/helpers'

import { SmsConsentDialog } from '@/features/user/settings/sections/account-details-card/sms-consent/ConsentDialog'
import { SmsConsentSource } from '@/features/user/settings/sections/account-details-card/sms-consent/smsConsentReducer'

// TODO: Migrate to V2
import FileUploadModal from '@/componentsV1/FileUpload/FileUploadModal'
import NoDocumentCheckboxLabel from '@/componentsV1/FileUpload/NoDocumentCheckboxLabel'

const OVERRIDE_CHECKBOX_CATEGORIES: string[] = [
  PostOnboardingTaskIdents.UPLOAD_TAX_RETURN_1040,
  PostOnboardingTaskIdents.UPLOAD_TAX_RETURN_1120S,
]

export const UserActionListItemExtras = ({
  userActionItemId,
  open,
  onClose,
}: {
  userActionItemId: number
  open: boolean
  onClose: () => void
}) => {
  const track = useAnalyticsTrack()
  const userActionItem = useReselector(
    selectUserActionItemById,
    userActionItemId
  )
  const documentCategory = useReselector(
    selectDocumentCategoryByUserActionItemId,
    userActionItemId
  )
  const currentTaxYear = useReselector(selectCurrentAnnualTaxYear)

  if (!userActionItem) {
    return null
  }

  const {
    actionItem: { identifier },
    templateValue,
  } = userActionItem

  if (identifier === PostOnboardingTaskIdents.ENTER_QTE_PAYMENTS) {
    return <OnboardingEstimatedTaxPaymentsModal open={open} onClose={onClose} />
  }

  if (identifier === PayrollTaskIdents.REVIEW_PAYROLL_COMPLIANCE) {
    return (
      <PayrollComplianceDialog
        open={open}
        onClose={onClose}
        onSuccess={() => {
          onClose()
          markUserActionItemCompleteIfExists(identifier, (event, properties) =>
            track(event, properties)
          )
        }}
      />
    )
  }

  if (documentCategory?.type && identifier) {
    return (
      <FileUploadModal
        year={
          userActionItem?.templateValue
            ? userActionItem.templateValue
            : currentTaxYear
        }
        open={open}
        close={onClose}
        userFacing
        documentType={documentCategory.type}
        categoryId={documentCategory.id}
        setUploadedFile={() =>
          markUserActionItemCompleteIfExists(identifier, (event, properties) =>
            track(event, properties)
          )
        }
        overrideCallback={() => {
          markUserActionItemCompleteIfExists(identifier, (event, properties) =>
            track(event, properties)
          )
        }}
        overrideCheckboxLabel={
          OVERRIDE_CHECKBOX_CATEGORIES.includes(identifier) && templateValue ? (
            `I did not file my ${templateValue} tax returns`
          ) : (
            <NoDocumentCheckboxLabel />
          )
        }
      />
    )
  }

  if (identifier === UserActionItemActionItemIdentifiers.smsOptIn) {
    return (
      <SmsConsentDialog
        source={SmsConsentSource.ACTION_ITEM}
        onClose={onClose}
      />
    )
  }

  return null
}
